<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
// import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Print Quotation",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
    // Loader,
  },
  data() {
    return {
      title: "Print Quotation",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Quotations",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",    
      id: atob(this.$route.params.id),

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("quotations", ["Quotation","SaveStatus"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Quotation ? this.Quotation.length : 1;
    },
    

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Quotation ? this.Quotation.length : 1;
  },
  updated() {
    setTimeout(() => {
      window.onafterprint = window.close;
      window.print();
      window.history.back();
    }, 1000);
  },
 
  methods: {
    ...mapActions({
      FetchQuotation: "quotations/fetchQuotation",
      
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  created() {
    this.FetchQuotation(this.id);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row px-5">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="quotation-title">
              <!-- <center> -->
                <div class="row py-5">    
                  <div class="col-md-3" align="center">
                    <img v-if="Quotation.business2.Businesslogo" :src="Quotation?Quotation.business2.Businesslogo:''" height="80" /> 
                  </div>   
                  <div class="col-md-9 text-center">                    
                    <span class="font-size-20 text-uppercase text-info"><strong>{{Quotation ? Quotation.business.name : ""}}</strong></span><br/>
                    <span class="font-size-18"><strong class="text-danger">Location:</strong> <b>{{Quotation ? Quotation.branch.address : ""}}</b></span><br/>
                    <span class="font-size-18"><strong class="text-danger">Tel:</strong> <b>{{Quotation?Quotation.contacts: ""}}</b></span><br/>
                    <span class="font-size-18"><strong class="text-danger">Email:</strong> <b>{{Quotation ? Quotation.branch.email : "---"}}</b></span><br/>
                  </div>
                </div>
            </div>
            <div style="border-top: 1px solid black;"></div>
            <div class="font-size-16 text-center py-3"><b>CUSTOMER QUOTATION</b></div>
            <div class="row font-size-15 py-3">
              <div class="col-6">
                <address>
                  <strong>Customer:</strong>
                 {{ Quotation.customer }} <br />
                </address>
              </div>
              <div class="col-6">
                <address>
                  <strong>Date:</strong>
                   :{{Quotation.date}} <br />
                   <strong>Quotation Number:</strong>  {{ Quotation.quotation_number }} 
                </address>
              </div>
            
            </div>            
            <div style="border-top: 1px solid black;"></div>
            <div class="p-2 mt-0">
              <h3 class="font-size-16">Order summary</h3>
            </div>
            <div class="table-responsive font-size-14">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th class="text-sm-end">Price</th>
                    <th class="text-sm-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pdt, index) in Quotation?Quotation.all:'---'" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{pdt.product}}</td>
                    <td>{{pdt.qty}} {{pdt.unit}}</td>
                    <td class="text-sm-end">{{pdt.price.toLocaleString()}}</td>
                    <td class="text-sm-end">{{pdt.total}}</td>
                  </tr>
                  
                  <tr>
                    <td colspan="4" class="border-0 text-sm-end">
                      <h4>Total</h4>
                    </td>
                    <td class="border-0 text-sm-end">
                      <h4 class="m-0">{{ Quotation.total.toLocaleString()}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>  
            <div style="border-top: 1px solid black;"></div>
            <div class="font-size-14 py-4 row">
              <div class="col-md-6">
                <span>{{Quotation ? Quotation.business.tagline : ''}}</span>
              </div>
              <div class="col-md-6" align="right">
                <strong>Prepared by:</strong> <span>{{Quotation ? Quotation.user : ''}}</span>
              </div>  
            </div>           
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>